import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container mx-auto kho-form-wrapper" }
const _hoisted_2 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_3 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_4 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_5 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_6 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_7 = { class: "flex justify-center mt-3 gap-x-1" }
const _hoisted_8 = { class: "mt-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LabelCustom = _resolveComponent("LabelCustom")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_DivCol = _resolveComponent("DivCol")!
  const _component_DivRow = _resolveComponent("DivRow")!
  const _component_TaiKhoanSelectionV2 = _resolveComponent("TaiKhoanSelectionV2")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_DanhSachKhoTable = _resolveComponent("DanhSachKhoTable")!
  const _component_PageContentBase = _resolveComponent("PageContentBase")!

  return (_openBlock(), _createBlock(_component_PageContentBase, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_form, {
          onSubmit: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.onSubmit(false)), ["prevent"]))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DivRow, { class: "mb-3 g-3" }, {
              default: _withCtx(() => [
                _createVNode(_component_DivCol, {
                  "additional-class": "pb-4",
                  cols: 2
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_LabelCustom, { "is-required": "" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Tên kho")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        class: "mb-0 w-full",
                        error: _ctx.nameErrorMess
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            ref: "tenKhoInputRef",
                            modelValue: _ctx.name,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
                            placeholder: "Tên kho",
                            name: "name",
                            onFocus: _cache[1] || (_cache[1] = ($event: any) => ($event.target.select()))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["error"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DivCol, {
                  "additional-class": "pb-4",
                  cols: 2
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_LabelCustom, { "is-required": "" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Mã kho")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        class: "mb-0 w-full",
                        error: _ctx.codeErrorMess
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.code,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.code) = $event)),
                            placeholder: "Mã kho",
                            name: "code",
                            onFocus: _cache[3] || (_cache[3] = ($event: any) => ($event.target.select()))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["error"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DivCol, {
                  "additional-class": "pb-4",
                  cols: 4
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_LabelCustom, { "is-required": "" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Địa chỉ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        class: "mb-0 w-full",
                        error: _ctx.addressErrorMess
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.address,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.address) = $event)),
                            placeholder: "Địa chỉ",
                            name: "address",
                            onFocus: _cache[5] || (_cache[5] = ($event: any) => ($event.target.select()))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["error"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DivCol, {
                  "additional-class": "pb-4",
                  cols: 4
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_LabelCustom, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Ghi chú kho")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { class: "mb-0 w-full" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.note,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.note) = $event)),
                            placeholder: "Ghi chú",
                            name: "note",
                            onFocus: _cache[7] || (_cache[7] = ($event: any) => ($event.target.select()))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_DivRow, { class: "mb-3" }, {
              default: _withCtx(() => [
                _createVNode(_component_DivCol, {
                  "additional-class": "pb-4",
                  cols: 12
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_LabelCustom, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Tài khoản")
                        ]),
                        _: 1
                      }),
                      (_openBlock(), _createBlock(_component_TaiKhoanSelectionV2, {
                        class: "w-100",
                        "ma-tai-khoan-prop": 
                  _ctx.taiKhoanData.maTaiKhoan
                    ? parseInt(_ctx.taiKhoanData.maTaiKhoan)
                    : undefined
                ,
                        "ma-chi-tiet-prop": 
                  _ctx.taiKhoanData.maChiTiet ? _ctx.taiKhoanData.maChiTiet : undefined
                ,
                        key: _ctx.taiKhoanSelectionKey,
                        onOnSelect: _ctx.onSelectTaiKhoan
                      }, null, 8, ["ma-tai-khoan-prop", "ma-chi-tiet-prop", "onOnSelect"]))
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_7, [
              (_ctx.isCreating)
                ? (_openBlock(), _createBlock(_component_ButtonCustom, {
                    key: 0,
                    classes: `rounded-none m-0`,
                    "button-type": _ctx.ButtonsType.ADD,
                    "color-type": _ctx.ButtonTypeColors.PRIMARY,
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onSubmit(true)))
                  }, {
                    "button-label": _withCtx(() => [
                      _createTextVNode("Lưu và tiếp tục")
                    ]),
                    _: 1
                  }, 8, ["button-type", "color-type"]))
                : _createCommentVNode("", true),
              _createVNode(_component_ButtonCustom, {
                classes: `rounded-none m-0`,
                "button-type": _ctx.ButtonsType.SAVE,
                "color-type": _ctx.ButtonTypeColors.SUCCESS,
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onSubmit(false)))
              }, {
                "button-label": _withCtx(() => [
                  _createTextVNode("Lưu")
                ]),
                _: 1
              }, 8, ["button-type", "color-type"]),
              (_ctx.isCreating)
                ? (_openBlock(), _createBlock(_component_ButtonCustom, {
                    key: 1,
                    classes: `rounded-none m-0`,
                    "button-type": _ctx.ButtonsType.REFRESH,
                    "color-type": _ctx.ButtonTypeColors.WARNING,
                    onClick: _ctx.clearForm
                  }, {
                    "button-label": _withCtx(() => [
                      _createTextVNode("Nhập lại")
                    ]),
                    _: 1
                  }, 8, ["button-type", "color-type", "onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_DanhSachKhoTable, {
            items: _ctx.khoItems,
            "show-delete-kho-button": true,
            "show-edit-button": true,
            onOnDeleteKho: _ctx.fetchData
          }, null, 8, ["items", "onOnDeleteKho"])
        ])
      ])
    ]),
    _: 1
  }))
}